import React from 'react';
import FeatureCards from "../../../components/FeatureCards/FeatureCards";
import CTA from "../../../components/Constant/cta/CTA";
import TimelineSection from "../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../components/WhySection/WhySection";
import LocationTimeline from "../../../components/LocationTimeline/LocationTimeline";
import ServiceCards from "../../../components/ServiceCards/ServiceCards ";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";

export default function CuraçaoGamingLicense (){

    return (
        <main className='main'>

            <IntroSection
                title="Curaçao Gaming License"
                subtitle="One of the World’s Oldest & Most Recognized iGaming Licenses"
                description =
                    "
                    For over <b>25 years</b>, <b>Curaçao</b> has been the <b>go-to jurisdiction</b> for <b>online casinos, sportsbooks, poker, and esports operators</b>. Known for its <b>affordability</b> and <b>speed of setup</b>, the <b>Curaçao gaming license</b> has been widely adopted by <b>operators worldwide</b>.
                    <br/>
                    In <b>2023</b>, <b>Curaçao</b> introduced a <b>new regulatory framework</b> under the <b>Curaçao Gaming Authority (CGA)</b>, replacing the old <b>Master/Sub-license model</b> with <b>direct B2C and B2B licenses</b>, making it more <b>compliant with international standards</b> while retaining its <b>cost advantages</b>.
                    "
                badges={
                    [
                        "B2C Operator Licenses",
                        "B2B Supplier Licenses",
                        "Crypto-Friendly"
                    ]
                }
                buttonText="Request a Curaçao Gaming License Proposal →"
                buttonLink="/quote"
                imageSrc={require("../../../assets/images/services/curaçao-gaming-licens-hero.png")}
                imageAlt="Gaming License Intro"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title='Why Curaçao Gaming License?'
                        blocks={[
                            {
                                items:
                                    [
                                        { title: "Most Recognized Offshore License", text: "trusted since the 1990s" },
                                        { title: "Modernized Regulation (2023)", text: "CGA replaces old Master/Sub model" },
                                        { title: "Cost-Effective", text: "cheaper than Malta, Isle of Man, or Gibraltar" },
                                        { title: "Single License Coverage", text: "casino, sports, lottery, poker, and esports under one license" },
                                        { title: "Crypto Acceptance", text: "Curaçao supports blockchain-based operators" }
                                    ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Types of Curaçao Gaming Licenses (New CGA Framework)"
                        blocks={[
                            {
                                title: "B2C Operator License",
                                items:
                                    [
                                        { text: "For online casino, sportsbook, poker, esports, and lottery operators" },
                                        { text: "Covers all verticals under one license" },
                                        { text: "Suitable for: startups, established casinos, crypto operators" }
                                    ]
                            },
                            {
                                title: "B2B Supplier License",
                                items:
                                    [
                                        { text: "For gaming software developers, white-label providers, payment processors, and game studios" },
                                        { text: "Required for companies supplying platforms or services to licensed B2C operators" }
                                    ]
                            },
                        ]}
                    />


                    <FeatureCards
                        title='Capital & Requirements'
                        features={
                            [
                                { title: "Capital Requirement", text: "no heavy minimum (unlike Malta)" },
                                { title: "Entity", text: "Curaçao-incorporated company required" },
                                { title: "Resident Presence", text: "local director or representative" },
                                { title: "AML/KYC", text: "operators must implement robust compliance" },
                                { title: "Audit", text: "annual financial and compliance audits under CGA" }
                            ]
                        }
                    />

                    <LocationTimeline
                        title='Benefits of Curaçao License'
                        item={
                            [
                                { title: "Wide Recognition", text: "accepted by payment processors, affiliates, and gaming communities" },
                                { title: "All-in-One License", text: "casino, betting, and poker covered" },
                                { title: "Crypto-Friendly", text: "supports BTC, ETH, USDT gaming platforms" },
                                { title: "Fast Setup", text: "historically 2–3 months, now 3–6 months under CGA" },
                                { title: "Low Cost", text: "far cheaper than EU/UK jurisdictions" }
                            ]
                        }
                    />

                    {/* Services */}
                    <ServiceCards
                        title='Licensing Process'
                        services={
                            [
                                { title: "Pre-Application Consultation", text: "choose B2C or B2B license" },
                                { title: "Company Incorporation", text: "register a Curaçao entity" },
                                { title: "Application Preparation", text: "business plan, AML framework, IT setup" },
                                { title: "CGA Review", text: "regulator checks fitness of shareholders & directors" },
                                { title: "License Issuance", text: "typically 3–6 months" }
                            ]
                        }
                    />

                    {/* Timeline */}
                    <TimelineSection
                        title='Timeline & Costs'
                        items={[
                            {
                                name: "Timeline",
                                description: "under the new CGA system.",
                                duration: " 3–6 months",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                            {
                                name: "Setup Costs",
                                description: "from USD 35,000+",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                            {
                                name: "Annual Fees",
                                description: "regulator fees, compliance audits, IT security testing",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                        ]}
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [
                                { text: "Experience in Curaçao licensing for over a decade" },
                                { text: "Guidance on migrating old sub-licenses to CGA direct licenses" },
                                { text: "Partnerships with platform providers, payment processors, affiliates" },
                                { text: "Comparative insights: Curaçao vs Malta vs Isle of Man vs Anjouan" },
                                { text: "Long-term support: compliance, renewals, and upgrades" }
                            ]
                        }
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    {/* Final CTA */}
                    <CTA title=
                            "
                            Looking to launch an <b>online casino</b>, <b>sportsbook</b>, or <b>gaming platform</b>?
                            "
                         description=
                             "
                            <b>Curaçao</b> remains one of the <b>most cost-effective</b> and <b>recognized iGaming jurisdictions</b>, now modernized under the <b>CGA</b>.
                             "
                         buttonText='Book a Curaçao Gaming License Consultation →'
                         buttonLink='/quote'
                    />
                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "What’s the difference between old and new Curaçao licenses?",
        content: [
            { type: "answer", text: "Old model: sub-licenses under a master license. New model (2023): direct B2C and B2B licenses from the CGA." },
        ],
    },
    {
        question: "Can Curaçao licenses cover crypto casinos?",
        content: [
            { type: "answer", text: "Yes — crypto gaming is accepted with proper AML/KYC." },
        ],
    },
    {
        question: "How long does it take to get licensed?",
        content: [
            { type: "answer", text: "3–6 months under CGA." },
        ],
    },
    {
        question: "Why Curaçao over Malta?",
        content: [
            { type: "answer", text: "Curaçao is cheaper, faster, and crypto-friendly, while Malta is stricter but more prestigious." },
        ],
    },
    {
        question: "What happens to old sub-license holders?",
        content: [
            { type: "answer", text: "They must transition to the new CGA framework." },
        ],
    },
];

const testimonialsData =
    [
        {
            quote: "We transitioned from a Curaçao sub-license to a CGA operator license. Offshore Advisory made the process simple.",
            author: "Chris P.",
            role: "Sportsbook CEO"
        },
        {
            quote: "Curaçao gave us the flexibility to launch a crypto casino quickly. Offshore Advisory handled incorporation and licensing.",
            author: "Lara M.",
            role: "Casino Founder"
        }
    ]
;